import type { ReactNode } from "react";
import { Cimage } from "../Cimage";
import { getCreferencePillLeadingStyle } from "./creferencePillContentModel";
const MEMBER_PROVIDER_ALT_FALLBACK = "provider";
export interface CreferencePillLeadingProps {
    isHovered: boolean;
    isMemberReference: boolean;
    leading: ReactNode;
    memberColor: string | null;
    memberProviderIconPath: string;
    memberProviderSlug: string;
}
export function CreferencePillLeading({ isHovered, isMemberReference, leading, memberColor, memberProviderIconPath, memberProviderSlug, }: CreferencePillLeadingProps): ReactNode {
    return (
    <span style={getCreferencePillLeadingStyle({
            isHovered,
            isMemberReference,
            memberColor,
        })}>
      {selectCreferencePillLeadingContent({
            isMemberReference,
            leading,
            memberProviderIconPath,
            memberProviderSlug,
        })}
    </span>
    );
}
function selectCreferencePillLeadingContent(input: {
    isMemberReference: boolean;
    leading: ReactNode;
    memberProviderIconPath: string;
    memberProviderSlug: string;
}): ReactNode {
    if (!input.isMemberReference) {
        return input.leading;
    }
    return (<Cimage src={input.memberProviderIconPath} alt={input.memberProviderSlug || MEMBER_PROVIDER_ALT_FALLBACK} width={15} height={15} static={true} objectFit="contain" style={{
            width: "15px",
            height: "15px",
        }}/>);
}
